const UitkLayoutFixedSizeMap = [
  ["zero", "zero"],
  ["fifteen", "fifteen"],
  ["sixteen", "sixteen"],
  ["twenty_four", "twenty_four"],
  ["seventy_two", "seventy_two"],
  ["seventy_six", "seventy_six"],
  ["eighty_eight", "eighty_eight"],
  ["ninety_six", "ninety_six"],
  ["one_hundred_four", "one_hundred_four"],
  ["one_hundred_twelve", "one_hundred_twelve"],
  ["one_hundred_twenty", "one_hundred_twenty"]
];
export const UitkLayoutFixedSizes = new Map(UitkLayoutFixedSizeMap);
const UitkLayoutPercentageSizeMap = [
  ["full_width", "full_width"],
  ["half_width", "half_width"],
  ["third_width", "third_width"],
  ["quarter_width", "quarter_width"]
];
export const UitkLayoutPercentageSizes = new Map(UitkLayoutPercentageSizeMap);
const UitkLayoutSizeMap = [
  ["zero", "zero"],
  ["fifteen", "fifteen"],
  ["sixteen", "sixteen"],
  ["twenty_four", "twenty_four"],
  ["seventy_two", "seventy_two"],
  ["seventy_six", "seventy_six"],
  ["eighty_eight", "eighty_eight"],
  ["ninety_six", "ninety_six"],
  ["one_hundred_four", "one_hundred_four"],
  ["one_hundred_twelve", "one_hundred_twelve"],
  ["one_hundred_twenty", "one_hundred_twenty"],
  ["double_one_hundred_twenty", "double_one_hundred_twenty"],
  ["full_width", "full_width"],
  ["half_width", "half_width"],
  ["third_width", "third_width"],
  ["two_third_width", "two_third_width"],
  ["quarter_width", "quarter_width"]
];
export const UitkLayoutSizes = new Map(UitkLayoutSizeMap);
